import * as yup from 'yup'

export const schema = yup.object({
  paymentType: yup
    .string()
    .nullable()
    .oneOf(['L', 'M'], 'This field is required')
    .required('This field is required'),
  pensionStartAge: yup
    .number()
    .nullable()
    .min(20, 'Please enter an age of 20 or older')
    .max(99, 'Please enter an age between 20 and 99')
    .required('This field is required'),
  monthlyPensionIncome: yup.number().nullable().required('This field is required'),
  lumpsumreceived: yup
    .string()
    .nullable()
    .when('paymentType', {
      is: 'L',
      then: schema =>
        schema.oneOf(['Y', 'N'], 'This field is required').required('This field is required'),
      otherwise: schema => schema,
    }),
  survivorFraction: yup
    .number()
    .nullable()
    .when('paymentType', {
      is: 'M',
      then: schema =>
        schema
          .min(0, 'Please enter a value between 0 and 100')
          .max(100, 'Please enter a value between 0 and 100'),
      otherwise: schema => schema,
    }),
})
